import { IDB_teams, IDB_syncParamsTeams } from '../IDB/IDB.dexie'
import { Sync_standardSync, type Sync_Params } from '../Sync/Sync.standardSync'
import { Serv_client } from '../Serv/Serv.client'
import type { TeamWithCount } from '../../../shared/domain/teams/types.no-deps'
import { setAllDeleted, setAllNotDeleted } from '../../../shared/lib/functional/deletable.no-deps'

export async function Team_sync() {
    await Sync_standardSync({
        params: IDB_syncParamsTeams(),
        sync,
        write,
        clear: () => IDB_teams().clear(),
    })
}

interface SyncResponse {
    syncedTeams: TeamWithCount[]
    deletions: number[]
    syncTime: Date
    teams: number[]
}

async function sync(params: Sync_Params): Promise<SyncResponse> {
    /**
     * An unfortunate assumption of sync api is that `teams` array means the users teams
     * so we can decide to resync if the teams changed.
     *
     * However here the `teams` are the actual entity of interest, so we rename them to `syncedTeams`
     * and fake the `teams` array by passing back what was given
     */
    const {
        teams: syncedTeams,
        deletions,
        syncTime,
    } = await Serv_client.syncTeams({ lastSyncTime: params.lastSyncTime })
    return { syncedTeams, deletions, syncTime, teams: params.teams }
}

async function write(response: SyncResponse) {
    const { syncedTeams, deletions } = response

    if (syncedTeams.length > 0) {
        await IDB_teams().bulkPut(setAllNotDeleted(syncedTeams))
    }

    if (deletions.length > 0) {
        await IDB_teams()
            .where('id')
            .anyOf(deletions)
            .toArray()
            .then(setAllDeleted)
            .then((ts) => IDB_teams().bulkPut(ts))
    }
}
